import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentRole, hasRoleAtLeast, UserRole } from '../../utils/permissions';
import logger from '../../utils/logger';

/**
 * RoleProtected — route element wrapper.
 *
 * 외곽의 ProtectedRoute 가 이미 인증/프로젝트 검증을 끝낸 state 에서, route 단위로
 * 최소 role 만 추가 검증하기 위한 가벼운 래퍼. 미달이면 redirectTo 로 Navigate
 * (default `/projects`).
 *
 * 사용 :
 *   <Route path="map-editor" element={
 *     <RoleProtected require="editor">
 *       <MapEditor />
 *     </RoleProtected>
 *   } />
 */
export interface RoleProtectedProps {
  require: UserRole;
  redirectTo?: string;
  children: React.ReactElement;
}

const RoleProtected: React.FC<RoleProtectedProps> = ({
  require,
  redirectTo = '/projects',
  children,
}) => {
  const role = getCurrentRole();
  if (!hasRoleAtLeast(role, require)) {
    logger.warn('[RoleProtected] Blocked', {
      path: window.location.pathname,
      role,
      require,
    });
    return <Navigate to={redirectTo} replace />;
  }
  return children;
};

export default RoleProtected;
